export const FormatTypes = {
  ASCII: 'ascii',
  BINARY: 'binary',
};

export default {
  FormatTypes,
};
